import { observer } from 'mobx-react-lite'
import React, { useState } from 'react'
import { PortfoliosTable } from '../components/portfolios/PortfoliosTable'
import type { ExpandedPerformanceMetrics } from '../components/table2/ad_grid_columns'
import { TableStore } from '../components/table2/table_store'
import { useSavedFiltersStore } from '../hooks/useSavedFiltersStore'
import { useUser } from '../hooks/useUser'
import { useTableHooksFromStore } from '../packages/blueprint-components/src/useTableHooks'
import { userStore } from '../stores/user_store'
import type { Portfolio } from '../types/portfolio'
import { loadAmazonPortfolios } from './amazon_portfolios_loader'

export const AmazonPortfolios = observer(() => {
    const { profile } = useUser()
    const [store] = useState<TableStore<Portfolio & ExpandedPerformanceMetrics>>(
        new TableStore(userStore, `portfolios`),
    )
    const savedFiltersStore = useSavedFiltersStore()

    const load = (params: any) => {
        if (!profile) {
            return Promise.resolve()
        }

        return loadAmazonPortfolios(profile, params)
    }
    const tableHooks = useTableHooksFromStore(load, {}, true, store)

    return (
        <PortfoliosTable
            store={store}
            savedFiltersStore={savedFiltersStore}
            tableHooks={tableHooks}
        />
    )
})
